import isEmpty from 'lodash/isEmpty';

const isPresent = data => !isEmpty(data);

export default isPresent;
